import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import api from '../lib/api';

// Compact, data-driven social-proof badge. Renders only when there is at least
// one published testimonial. Pulls the real average + count from /api/testimonials.
export const TrustBadge = ({ variant = 'light', className = '', to = '#testimonials', testid = 'trust-badge' }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/testimonials')
      .then((res) => setData({ avg: res.data?.average_rating, count: res.data?.count || 0 }))
      .catch(() => setData(null));
  }, []);

  if (!data || !data.count || data.avg == null) return null;

  const { avg, count } = data;
  const dark = variant === 'dark';
  const base = dark
    ? 'bg-burgundy/90 text-cream border border-rose/30'
    : 'bg-white/80 text-burgundy border border-rose/50';

  const content = (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-sm backdrop-blur-sm shadow-sm transition-transform hover:-translate-y-0.5 ${base} ${className}`}
    >
      <span className="flex items-center gap-0.5">
        {Array.from({ length: 5 }).map((_, s) => {
          const filled = s < Math.round(avg);
          return <Star key={s} className="w-3.5 h-3.5" fill={filled ? '#A44758' : 'none'} stroke="#A44758" />;
        })}
      </span>
      <span className="font-semibold">{avg}</span>
      <span className={dark ? 'text-cream/70' : 'text-mahogany/70'}>
        from {count} {count === 1 ? 'seeker' : 'seekers'}
      </span>
    </span>
  );

  if (!to) return content;
  return <a href={to} aria-label={`${avg} out of 5 from ${count} reviews`}>{content}</a>;
};

export default TrustBadge;
